import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon.react';
import styles from 'components/Label/Label.scss';
import Tooltip from 'react-autotip'

export default function Toggle(props) {
  let classes = [styles.label];
  if (props.className) {
    classes.push(styles[props.className]);
  }

  return (
    <div key={Math.random().toString(36).substr(2, 5)} className={classes.join(' ')}>
      {
        props.iconName
          ? <Icon name={props.iconName} width={props.sizeWidth ? props.sizeWidth : 16} height={props.sizeHeight ? props.sizeHeight : 16} colored={props.coloredIcon} />
          : null
      }
      <div className={styles.text}>
        {props.text}
        {
          props.tooltipText &&
            <Tooltip text={<div dangerouslySetInnerHTML={{ __html: props.tooltipText }} />} tooltipStyles={{
              color: '#fff',
              fontFamily: 'Ubuntu',
              fontSize: 14,
              fontWeigt: 300,
              borderRadius: 4,
              maxWidth: props.tooltipTextWidth || 300,
              unit: 4,
              lightgrey: '#222933',
              opaqueGrey: '#222933',
            }}>
              <div>
                <Icon name='icon-info' width={16} height={16} fill="#47689f" />
              </div>
            </Tooltip>
        }
      </div>
      {props.description ? <div className={styles.description}>{props.description}</div> : null}
    </div>
  );
}


Toggle.propTypes = {
  ppp: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.node,
  description: PropTypes.node,
};
